import { useCallback, useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function Character() {
    const { t } = useLang('bladeroboticlawnmower');
    const domRef = useRef<HTMLDivElement>(null);
    const domChildRef = useRef<HTMLDivElement>(null);
    const arrTopRef = useRef<Array<number>>([0]);
    const arrHeightRef = useRef<Array<number>>([]);
    const [tabActive, setTabActive] = useState<string>('1');
    const videoAutoCarRef = useRef<HTMLVideoElement>(null);

    const domRef2 = useRef<HTMLDivElement>(null);
    const domChildRef2 = useRef<HTMLDivElement>(null);
    const arrTopRef2 = useRef<Array<number>>([0]);
    const arrHeightRef2 = useRef<Array<number>>([]);
    const [tabActive2, setTabActive2] = useState<string>('1');
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    // 视频异步加载延迟资源
    const [sources, setSources] = useState<string[] | null>(null);

    const initMove = useCallback((dom: any, arrHRef: number[], arrTRef: number[], offset) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];
            arrHRef.push(item.clientHeight);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientHeight + offset);
            } else {
                arrTRef.push(item.clientHeight + offset);
            }
        }
    }, []);

    const changeTab = useCallback((index: string) => {
        setTabActive(index);
        const ind = Number(index) - 1;
        (domChildRef.current as HTMLDivElement).style.cssText = `height: ${arrHeightRef.current[ind]}px; top: ${arrTopRef.current[ind]}px`;

        const video: any = videoAutoCarRef.current;
        if (index === '2') {
            video?.setCurrentTime(0);
            video?.play();
        } else {
            video?.pause();
        }
    }, []);

    const changeTab2 = useCallback((index: string) => {
        setTabActive2(index);
        const ind = Number(index) - 1;
        (domChildRef2.current as HTMLDivElement).style.cssText = `height: ${arrHeightRef2.current[ind]}px; top: ${arrTopRef2.current[ind]}px`;
    }, []);

    useEffect(() => {
        // 初始化tab1切换数据
        initMove(domRef.current, arrHeightRef.current, arrTopRef.current, -12);
        initMove(domRef2.current, arrHeightRef2.current, arrTopRef2.current, 40);
        changeTab('1');
        changeTab2('1');

        AniContainer.create({
            triggerElement: '.character-video-load',
            triggerHook: 1,
            offset: 0,
            duration: 0,
            onLazyLoad: async () => {
                setSources(['/video/blade/detail/pc/sensor_01.webm', '/video/blade/detail/pc/sensor_01.mp4']);
            },
        });
    }, []);

    return (
        <div className={css['mod-character']}>
            <div id="character" className="point"></div>
            <div className="character-box character-video-load">
                <div className="character-fl">
                    <p className="character-title">{t('detail.anti_title')}</p>
                    <p className="character-desc">{t('detail.anti_subtitle')}</p>
                    <div ref={domRef} className={`character-tab active-0${tabActive}`}>
                        <button onClick={() => changeTab('1')}>
                            <span className="title">{t('detail.anti_title1')}</span>
                            <span className="desc">{t('detail.anti_desc1')}</span>
                        </button>
                        <button onClick={() => changeTab('2')}>
                            <span className="title">{t('detail.anti_title2')}</span>
                            <span className="desc">{t('detail.anti_desc2')}</span>
                        </button>
                        <button onClick={() => changeTab('3')}>
                            <span className="title">{t('detail.anti_title3')}</span>
                            <span className="desc">{t('detail.anti_desc3')}</span>
                        </button>
                        <em ref={domChildRef}></em>
                    </div>
                </div>
                <div className="character-img">
                    <div className={`character-fr-box ${tabActive === '1' ? 'active' : ''}`}>
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/10-1@2x.webp')}
                            src={require('@publicLocal/blade/detail/pc/10-1@2x.jpg')}
                            alt={t('detail.sec1_title')}
                            aria-label={t('detail.sec1_title')}
                        />
                    </div>
                    <div className={`character-fr-box character-video ${tabActive === '2' ? 'active' : ''}`}>
                        <EFVideo ref={videoAutoCarRef} className="video" autoPlay={false} sources={sources} />
                    </div>
                    <div className={`character-fr-box ${tabActive === '3' ? 'active' : ''}`}>
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/10-3@2x.webp')}
                            src={require('@publicLocal/blade/detail/pc/10-3@2x.jpg')}
                            alt={t('detail.sec1_title')}
                            aria-label={t('detail.sec1_title')}
                        />
                    </div>
                </div>
            </div>
            <div id="services" className="character-box">
                <div className="character-fl">
                    <p className="character-title">{t('detail.bladeh_listbox_title')}</p>
                    {/* <p className="character-desc">{t('detail.anti_subtitle')}</p> */}
                    <div ref={domRef2} className={`character-tab character-tab2 active-0${tabActive2}`}>
                        <button onClick={() => changeTab2('1')}>
                            <span className="title">{t('detail.bladeh_listbox_1')}</span>
                        </button>
                        <button onClick={() => changeTab2('2')}>
                            <span className="title">{t('detail.bladeh_listbox_2')}</span>
                        </button>
                        <button onClick={() => changeTab2('3')}>
                            <span className="title">{t('detail.bladeh_listbox_3')}</span>
                        </button>
                        <button onClick={() => changeTab2('4')}>
                            <span className="title">{t('detail.bladeh_listbox_4')}</span>
                        </button>
                        <em ref={domChildRef2}></em>
                    </div>
                </div>
                <div className="character-img">
                    <div className={`character-fr-box ${tabActive2 === '1' ? 'active' : ''}`}>
                        <NextImage
                            webpSrc={require(`@publicLocal/blade/detail/pc/11-1${['au'].includes(locale) ? `_${locale}` : ''}@2x.webp`)}
                            src={require(`@publicLocal/blade/detail/pc/11-1${['au'].includes(locale) ? `_${locale}` : ''}@2x.jpg`)}
                            alt={t('detail.sec1_title')}
                            aria-label={t('detail.sec1_title')}
                        />
                    </div>
                    <div className={`character-fr-box ${tabActive2 === '2' ? 'active' : ''}`}>
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/11-2@2x.webp')}
                            src={require('@publicLocal/blade/detail/pc/11-2@2x.jpg')}
                            alt={t('detail.bladeh_listbox_2')}
                            aria-label={t('detail.bladeh_listbox_2')}
                        />
                    </div>
                    <div className={`character-fr-box ${tabActive2 === '3' ? 'active' : ''}`}>
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/11-3@2x.webp')}
                            src={require('@publicLocal/blade/detail/pc/11-3@2x.jpg')}
                            alt={t('detail.sec1_title')}
                            aria-label={t('detail.sec1_title')}
                        />
                    </div>
                    <div className={`character-fr-box ${tabActive2 === '4' ? 'active' : ''}`}>
                        <NextImage
                            webpSrc={require('@publicLocal/blade/detail/pc/11-4@2x.webp')}
                            src={require('@publicLocal/blade/detail/pc/11-4@2x.jpg')}
                            alt={t('detail.sec1_title')}
                            aria-label={t('detail.sec1_title')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
